import { Object3D } from "three";
import Ball from "./Ball";
import Pin from "./Pin";
import Track from "./Track";

export default class World {

  constructor(scene) {
    this.scene = scene
    this.ball = new Ball(scene)
    this.pinsRows = Array.from({length: 4}, (_, rowIndex) => {
      const row = new Object3D()
      for (let i = 0; i < rowIndex+1; i++) {        
        row.add(new Pin(scene, i, rowIndex))
      }

      return row
    })

    this.track = new Track(scene)
  }

  getPins() {
    return this.pinsRows.reduce((pins, row) => {
      return pins.concat(row.children)
    }, [])
  }
}